import type { TypeMouseConfig, TypeMouseState } from './types';

// ----------------------------------------------------------------------------

class MouseManager {
    readonly #listeners = new Map<HTMLElement, (evt: MouseEvent) => void>();

    readonly #state: TypeMouseState = {
        elements: [],
        config: {},
    };

    constructor(config: TypeMouseConfig = {}) {
        this.#state.config = config;
    }

    getState(): TypeMouseState {
        return {
            config: { ...this.#state.config },
            elements: [...this.#state.elements],
        };
    }

    gets(): TypeMouseState {
        return this.getState();
    }

    add(element: HTMLElement): void {
        if (this.#listeners.has(element)) {
            return;
        }

        this.#state.elements.push(element);

        if (typeof this.#state.config.fnAdded === 'function') {
            this.#state.config.fnAdded(element);
        }

        const onMouseDown = (evt: MouseEvent): void => {
            if (typeof this.#state.config.fnAction === 'function') {
                this.#state.config.fnAction.call(element, evt);
            }
        };

        this.#listeners.set(element, onMouseDown);
        element.addEventListener('mousedown', onMouseDown);
    }

    purge(): void {
        for (const [element, listener] of this.#listeners.entries()) {
            element.removeEventListener('mousedown', listener);
        }

        this.#listeners.clear();
        this.#state.elements = [];
        this.#state.config = {};
    }

    destroy(): void {
        this.purge();
    }
}

// ----------------------------------------------------------------------------

export default MouseManager;
